<div class="body-categoria py-5 px-2">
    <div class="box-content mx-auto mw-100">
        <img class="mw-100 d-block mx-auto margin-logo" width="30%" src="assets/img/logo.png" alt="">
        <p class="text-center fs-5">Tiendas QuinChau</p>
        
        <mat-spinner *ngIf="categorias.cargando" class="d-block mx-auto mb-5" diameter="20"></mat-spinner>
       
        <ng-container *ngFor="let categoria of categorias.registros; let i = index;">
            <a class="btn mb-3 cursor-pointer" 
                (click)="seleccionarCetegoria(categoria)">{{ categoria.categorydescription }}</a>
        </ng-container>
            
    </div>

    
</div>